module.exports = __webpack_public_path__ + "img/layout-3.48b898c0.jpg";